import React, { useEffect, useState } from 'react'
import './index.css';

export const Resumen = ({cantidad, type}) => {
    const [resumen, setResumen] = useState('')

    useEffect(() => {
        switch (type) {
            case 'entregado':
                setResumen('Entregado');
                break;
            case 'en-proceso':
                setResumen('En proceso');
                break;
            case 'error-nadin':
                setResumen('Error NADIN');
                break;
            case 'error-sfdc':
                setResumen('Error SFDC');
                break;
            case 'error-nadin-sfdc':
                setResumen('Error NADIN SFDC')
            default:
                break;
        }
    },[type])


  return (
    <div className={`container-tag-${type}`}>
        <p>{resumen}:</p>
        <p>{cantidad}</p>
    </div>
  )
}
